/**
 * The one width the responsive shell branches on in script (client, 2026-09-14).
 *
 * `base.css` ("Responsive shell") re-cuts the layout at 900px: below it the sidebar dock is a
 * drawer over the map and the floating widgets span the map's width, so anything open on a
 * cold load *is* the map. Three components ask the same question at boot — the dock
 * (`state.ts`), the legend and the hierarchy widget — and they must agree on the number, so it
 * lives here once and matches the stylesheet's `@media (max-width:900px)` exactly.
 *
 * Read defensively: jsdom has no `matchMedia`, and there the desktop answer stands.
 */
export const COMPACT_QUERY = '(max-width: 900px)';

export function isCompactViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(COMPACT_QUERY).matches;
}
